import { Action, createReducer, on } from '@ngrx/store';
import { CardModel } from '../../../core/models/payment.model';
import { PaymentMandateRequest } from '../../payment-mandate/models/payment-mandate.model';
import { loadAddCreditCards } from '../actions/add-credit-card.actions';
import { IAddCardResponse } from '../models/add-card.model';
import * as fromAddCardActions from '../actions';

export const addCardFeatureKey = 'addCard';

export interface CardState {
  addCardRequest: CardModel;
  addCardResponse: IAddCardResponse;
  addCardFailure: Error | any;

  saveCard: PaymentMandateRequest;
}

export const initialState: CardState = {
  addCardRequest: undefined,
  addCardResponse: undefined,
  addCardFailure: undefined,
  saveCard: undefined
};

export const reducer = createReducer(
  initialState,

  on(loadAddCreditCards, (state, action) => ({
    ...state,
    saveCard: action.saveCard
  })),

  on(fromAddCardActions.loadAddCards, (state, action) => ({
    ...state,
    addCardRequest: action.request
  })),
  on(fromAddCardActions.loadAddCardsSuccess, (state, action) => ({
    ...state,
    addCardResponse: action.response
  })),
  on(fromAddCardActions.loadAddCardsFailure, (state, action) => ({
    ...state,
    addCardFailure: action.error
  }))
);

export const getSaveCard = (state: CardState) => state.saveCard;
export const getAddCardRequest = (state: CardState) => state.addCardRequest;
export const getAddCardResponse = (state: CardState) => state.addCardResponse;
